import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b156490&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b156490')) {
      api.createRecord('4b156490', component.options)
    } else {
      api.reload('4b156490', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b156490&", function () {
      api.rerender('4b156490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ts/components/map/index.vue"
export default component.exports